import type { IComponentController, IOnChangesObject } from 'angular';
import template from './mx-adaptive-card-widget.component.html';

// Simplified analogue of DashboardWidgetController: renders one adaptive card record's runtime
// template via mx-bind-html-compile, with its own controllerAs 'vm' so the compiled template's
// `vm.dataModel` resolves to this card's dataModel, not to a shared list controller.
export class AdaptiveCardWidgetController implements IComponentController {
	public dataModel!: unknown;
	public template?: string;
	public serviceContextInfo?: { widgetId: string; viewName: string };
	public internalTemplate = '';
	public onHide!: () => void;

	$onChanges(onChangesObj: IOnChangesObject) {
		if (onChangesObj.template) {
			this.internalTemplate = this.template || '';
		}
	}

	public hide() {
		this.onHide();
	}
}

export const AdaptiveCardWidgetComponent = {
	name: 'mxAdaptiveCardWidget',
	controller: AdaptiveCardWidgetController,
	controllerAs: 'vm',
	template,
	bindings: {
		dataModel: '<model',
		template: '<',
		serviceContextInfo: '<',
		onHide: '&',
	},
};
